import { useCallback, useEffect, useRef, useState } from 'react'
import { useBrowserIsOnline } from '$hooks/use-browser-connection'

const INTERVAL_DELAY = 1000
const PERCENTAGE_INCREASE_RATE = 8
const MIN_USER_WAIT_MS = 10000

export function useFakeProgressWithOnlineStatus(
  cb: (() => Promise<unknown>) | undefined,
) {
  const online = useBrowserIsOnline()
  const [percent, setPercent] = useState<number>(0)
  const [updateIsOver, setUpdateIsOver] = useState<boolean>(false)
  const timerRef = useRef<NodeJS.Timer>()

  const finishProgress = useCallback(() => {
    setUpdateIsOver(true)
    setPercent(100)

    if (timerRef.current) {
      clearInterval(timerRef.current)
      timerRef.current = undefined
    }
  }, [])

  useEffect(() => {
    if (!cb) return
    const startTime = Date.now()

    timerRef.current = setInterval(() => {
      if (!online) return

      setPercent(oldPercent =>
        Math.min(80, oldPercent + PERCENTAGE_INCREASE_RATE),
      )
    }, INTERVAL_DELAY)

    cb().then(() => {
      console.log('>>>> SW Registration Updated!')

      const timeToWait = MIN_USER_WAIT_MS - (Date.now() - startTime)

      if (timeToWait > 0) setTimeout(finishProgress, timeToWait)
      else finishProgress()
    })

    return () => {
      clearInterval(timerRef.current)
    }
  }, [cb])

  return { percent, updateIsOver, finishProgress }
}
